import useTranslation from 'hooks/useTranslation';
import { useEffect } from 'react';
import { useState } from 'react';

import generalStyle from '../../layouts/auth/index.style';
import RegisterForm from './RegisterForm';
import SocialNetwotks from './SocialNetwotks';
import { useRouterWithLang } from 'hooks/useRouterWithLang';

function Register() {
  const { TRANSLATIONS } = useTranslation();
  const router = useRouterWithLang();
  const { data } = router.query;
  const [dataEncode, setDataEncode] = useState(null);
  const [step, setStep] = useState(1);

  useEffect(() => {
    if (data && step === 1) {
      let _dataEncode = JSON.parse(window.atob(data));
      setStep(2);
      setDataEncode(_dataEncode);
      router.replace('/register');
    }
  }, [data, step, router]);

  return (
    <div className="register-content">
      <div className="title">
        {step === 1 ? (
          <>
            <h1>{TRANSLATIONS.auth.getstarted}</h1>
            <div>
              <p>{TRANSLATIONS.auth.subtitle}</p>
            </div>
          </>
        ) : (
          <>
            <h2>{TRANSLATIONS.auth.welcome}</h2>
            <div>
              <p>{TRANSLATIONS.auth.fewQuestion}</p>
            </div>
          </>
        )}
      </div>
      {(!data || dataEncode) && (
        <RegisterForm data={dataEncode} step={step} setStep={setStep} />
      )}
      {false && <SocialNetwotks />}
      <style jsx>{generalStyle}</style>
      <style>{`
      .register-content{
        min-height: 50vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
      }
      .title h1 {
        margin-bottom: 16px;
        font-size: 40px;
        font-weight: 600;
        line-height: 35px;
      }
      .title {
        margin-bottom:1em
      }
      @media only screen and (max-width: 425px) {
        .title {
          margin-bottom: 1em;
        }
        .title h1 {
          margin: 0;
          font-size: 22px;
          font-weight: 600;
          line-height: 25px;
        }
        .title p{
          margin-top:5px;
          font-size:15px;
        }
      }
      .title p{
        font-size:15px;
      }
      .link-wrapper {
        font-size: 13px;
        font-weight: 400;
        line-height: 25px;
        text-align: center;
        margin-top:1em;
      }
      .link-wrapper span {
      }
      .link-wrapper a {
        color: var(--primary);     
        font-weight: 500;
        margin-left: 5px;
      }
      `}</style>
    </div>
  );
}

export default Register;
